import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getGroupedProcedures = (token, memId) => {
    let baseUrl = tools.ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", "HR");
    const url = encodeURI(tools.buildUrl(baseUrl, 'members/benefits/getgroupedcostprocedures'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getGroupedProceduresByCPT = (token, memId) => {
    let baseUrl = tools.ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", "HR");
    const url = encodeURI(tools.buildUrl(baseUrl, 'members/benefits/getgroupedcostproceduresbycpt'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProceduresByCPT", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProceduresByCPT.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getProcedureCostValues2 = (token, MemberNumber, GroupDescript) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/member/benefits/getproccostvals2'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MEMBER_NBR: MemberNumber,
            BENEFIT_NAME: GroupDescript?.benefit_name

        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getProceduresCost = (token, procedureId, groupDescript, cptCode, copay, coinsurance, has_deductible, deductible_remaining, oop_remaining) => {
    let baseUrl = tools.ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", "HR");
    const url = encodeURI(tools.buildUrl(baseUrl, 'members/benefits/getproccosts'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            GROUP_DESCRIPT: groupDescript,
            CPT_CODE: cptCode,
            PROCEDURE_ID: procedureId,
            COPAY: copay,
            COINSURANCE: coinsurance,
            HAS_DEDUCTIBLE: has_deductible,
            DEDUCTIBLE_REMAINING: deductible_remaining,
            OOP_REMAINING: oop_remaining

        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetGroupedCostProcedures.Failure", start, url, err); return Promise.reject(err);
    });
};